import React, { useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  border-radius: 50px;
  height: 20px;
  width: 100%;
  background-color: none;
`;

const Filler = styled.div<{ completed: number }>`
  background-color: var(--theme-palette-green);
  border-radius: inherit;
  height: 100%;
  width: ${(props) => props.completed}%;
  text-align: right;
  transition: width 3s;
  max-width: 100%;
`;

export function ProgressBar() {
  const [percentage, setPercentage] = React.useState(0);

  useEffect(() => {
    setPercentage(100);
  }, [percentage]);

  return (
    <Wrapper>
      <Filler completed={percentage} />
    </Wrapper>
  );
}
